import React from "react";
import { cn } from "@/lib/utils/common";

type PopoverTriggerButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const PopoverTriggerButton = React.forwardRef<HTMLButtonElement, PopoverTriggerButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          "flex h-10 w-full items-center justify-between",
          "rounded-md",
          "border border-input",
          "bg-background px-3 py-2",
          "text-sm",
          "ring-offset-background",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      >
        {children}
      </button>
    );
  },
);
PopoverTriggerButton.displayName = "PopoverTriggerButton";
